import { biliBridge, inBiliApp as inApp } from '@bilibili/js-bridge'

export const inBiliApp = inApp

/**
 * 关闭webview
 */
export const closeView = () => biliBridge.callNative({
  method: 'global.closeBrowser',
})
